export function mountReactComponent(selector, importer) {
  if (!document.querySelector(selector)) {
    return Promise.resolve();
  }

  return Promise.all([import(/* webpackChunkName: "react-helper" */ './helper'), importer()]).then(
    ([{ attachNext }, { default: Component }]) => {
      attachNext(selector, Component);
    }
  );
}
